import { render, staticRenderFns } from "./DigisacChat.vue?vue&type=template&id=83255114&"
import script from "./DigisacChat.vue?vue&type=script&lang=js&"
export * from "./DigisacChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports